import type { CargoRes } from 'api/swagger';
import type { CargoItemGroup } from 'shared/utils/cargos/group-cargos-by-size';

export function formatCargoData(cargoItems: CargoItemGroup[], cargo: CargoRes) {
  let cargoDataString = cargoItems
    .map((item) => `${item.count} items - ${item.length}x${item.width}x${item.height} m`)
    .join('\n');

  cargoDataString = `${cargoDataString}\n${cargo.totalWeight || cargo.calculatedTotalWeight} kg`;
  cargoDataString = `${cargoDataString}; LDM: ${cargo.totalLDM}`;

  return cargoDataString;
}
